import localhost from "../../../apis/localhost";
import { showErrorModal } from "../../app/actions/error";
import {
  setAllowedSitesPolicy,
  setAllowedSitesPolicyLoading,
} from "../allowedSitesSlice";
import { REQUEST_CONFIG } from "./allowedSitesConstants";
import {
  allowedSitesUrl,
  messageOf,
  redirectUnlessSharepointError,
  statusOf,
} from "./allowedSitesUtils";

export const fetchAllowedSitesPolicy =
  ({ isCloudMode }) =>
  async (dispatch) => {
    dispatch(setAllowedSitesPolicyLoading(true));
    try {
      const { data } = await localhost.get(
        allowedSitesUrl(isCloudMode),
        REQUEST_CONFIG
      );
      dispatch(setAllowedSitesPolicy(data));
    } catch (error) {
      redirectUnlessSharepointError(error);
      if (statusOf(error) !== 404) {
        dispatch(
          showErrorModal(
            { message: messageOf(error, "Failed to load the allowed sites") },
            "Allowed Sites"
          )
        );
      }
    } finally {
      dispatch(setAllowedSitesPolicyLoading(false));
    }
  };
